/* Mock routes — dashboard, planting locations. */

import type { ActivityEntry, DashboardSummary } from '@core/types'
import { db } from '../store'
import { CLIMATE_BY_GOVERNORATE } from '../data/climate'
import { readQueryNumber, type MockRoute } from '../types'
import { buildDashboardSummary, EMPTY_DASHBOARD } from './shared'

export const dashboardRoutes: MockRoute[] = [
  {
    method: 'GET',
    pattern: '/dashboard/summary',
    handler: () => buildDashboardSummary(),
    emptyState: EMPTY_DASHBOARD satisfies DashboardSummary,
  },
  {
    method: 'GET',
    pattern: '/dashboard/activity',
    handler: ({ query }) => {
      const limit = readQueryNumber(query, 'limit') ?? 10
      return db.activity.slice(0, limit)
    },
    emptyState: [] satisfies ActivityEntry[],
  },
  {
    method: 'GET',
    pattern: '/locations',
    handler: () =>
      Object.entries(CLIMATE_BY_GOVERNORATE).map(([name, profile]) => ({ name, ...profile })),
    emptyState: [],
  },
]
